import request from '@/plugins/axios'

/** S 预约列表 **/
// 预约列表
export const apiAppLists = (params: any) => request.get('/reservationMessage.reservationMessage/lists', {params})
/**
 * 获取应用详情信息的API请求函数
 * @param params - 请求参数对象，包含查询应用详情所需的各项参数
 * @returns 返回一个Promise，通过request.get发送GET请求获取应用详情数据
 */
export const apiAppDetail = (params: any) => request.get('/reservationMessage.reservationMessage/detail', {params})

